import { FC } from "react";
import { G, Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdAnnounce: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 100 100" fill="none" {...props}>
    <G>
      <Path
        d="m18.355 76.109c0.13281 0.80078 0.82812 1.3906 1.6445 1.3906h6.668c0.48828 0 0.95703-0.21484 1.2695-0.58984 0.31641-0.375 0.45312-0.86719 0.37109-1.3516l-2.9688-17.816 24.66 9.2461v2.1797c0 1.8398 1.4961 3.332 3.332 3.332h6.668c1.8359 0 3.332-1.4961 3.332-3.332v-43.332c0-1.8398-1.4961-3.332-3.332-3.332h-6.668c-1.8359 0-3.332 1.4961-3.332 3.332v2.1758l-25.305 9.4883h-11.363c-1.8359 0-3.332 1.4961-3.332 3.332v13.332c0 1.8398 1.4961 3.332 3.332 3.332h1.9219zm3.0547-1.9414-2.7773-16.668h3.2891l2.7773 16.668zm31.922-48.336h6.668v43.332l-6.668 0.003907zm-3.332 37.598-23.332-8.75v-14.355l23.332-8.75zm-36.668-22.598h10v13.332h-6.668l-3.332 0.003907z"
        fill="currentColor"
      />
      <Path
        d="m88.332 45.832h-20c-0.92188 0-1.668 0.74609-1.668 1.668s0.74609 1.668 1.668 1.668h20c0.92188 0 1.668-0.74609 1.668-1.668s-0.74609-1.668-1.668-1.668z"
        fill="currentColor"
      />
      <Path
        d="m66.879 38.883c0.26562 0.64063 0.88672 1.0312 1.5391 1.0312 0.21484 0 0.42969-0.042968 0.63672-0.12891l17.914-7.4102c0.84766-0.35156 1.2539-1.3281 0.90234-2.1758-0.35156-0.85156-1.3242-1.25-2.1758-0.90234l-17.914 7.4102c-0.84766 0.35156-1.2539 1.3242-0.90234 2.1758z"
        fill="currentColor"
      />
      <Path
        d="m86.973 62.629-17.914-7.4102c-0.85156-0.35156-1.8242 0.050781-2.1758 0.90234-0.35156 0.85156 0.050782 1.8242 0.90234 2.1758l17.914 7.4102c0.21094 0.085938 0.42578 0.12891 0.63672 0.12891 0.65234 0 1.2734-0.38672 1.5391-1.0312 0.34766-0.85156-0.054688-1.8242-0.90234-2.1758z"
        fill="currentColor"
      />
    </G>
  </Svg>
);

export default PdAnnounce;
